import { useState, useEffect } from 'react';
import StatusIndicator from '@cloudscape-design/components/status-indicator';
import { getResolverGroupCoverage } from '../api/tickets';

/**
 * Shows resolver-group tagging coverage as "X% (Y of Z)". Tickets without a
 * resolver group (e.g. those the service can't read from Tickety) are invisible
 * to group-scoped themes, so this tells users how complete group filtering is.
 */
export function CoverageIndicator() {
  const [text, setText] = useState<string | null>(null);
  const [type, setType] = useState<'info' | 'warning'>('info');

  useEffect(() => {
    let active = true;
    getResolverGroupCoverage()
      .then(({ total, tagged, coveragePct }) => {
        if (!active) return;
        setText(
          `Resolver-group coverage: ${coveragePct}% (${tagged.toLocaleString()} of ${total.toLocaleString()})`,
        );
        setType(coveragePct >= 90 ? 'info' : 'warning');
      })
      .catch(() => {
        /* omit the indicator if coverage can't be loaded */
      });
    return () => {
      active = false;
    };
  }, []);

  if (!text) return null;
  return <StatusIndicator type={type}>{text}</StatusIndicator>;
}
